var render = function render(_c,_vm){return _c('div',_vm._g({staticClass:"ListItem",class:{active: _vm.props.active}},_vm.listeners),[_vm._t("default",function(){return [_vm._v("TEXT")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }